// Core
import { router } from './core/router.js';

// Components
import './components/app-shell.js';
import './components/app-nav.js';
import './components/app-toast.js';
import './components/loading-spinner.js';

// Shared
import './components/confirm-dialog.js';

// Pages — login
import './components/login/login-page.js';
import './components/login/verify-page.js';

// Pages — user
import './components/user/availability-page.js';
import './components/user/published-schedule-page.js';
import './components/user/profile-page.js';

// Pages — admin
import './components/admin/people/people-list-page.js';
import './components/admin/people/person-edit-page.js';
import './components/admin/quarters/quarters-list-page.js';
import './components/admin/quarters/quarter-edit-page.js';
import './components/admin/dashboard-page.js';
import './components/admin/schedule/schedule-editor-page.js';
import './components/admin/matrix/availability-matrix-page.js';
import './components/admin/roles/roles-page.js';
import './components/admin/settings/settings-page.js';

// Register routes
router.register([
  { pattern: '/login', component: 'login-page' },
  { pattern: '/verify', component: 'verify-page' },
  { pattern: '/availability', component: 'availability-page', guard: 'auth' },
  { pattern: '/schedule', component: 'published-schedule-page' },
  { pattern: '/profile', component: 'profile-page', guard: 'auth' },
  { pattern: '/admin/dashboard', component: 'admin-dashboard-page', guard: 'admin' },
  { pattern: '/admin/people', component: 'people-list-page', guard: 'admin' },
  { pattern: '/admin/people/new', component: 'person-edit-page', guard: 'admin' },
  { pattern: '/admin/people/:id', component: 'person-edit-page', guard: 'admin' },
  { pattern: '/admin/quarters', component: 'quarters-list-page', guard: 'admin' },
  { pattern: '/admin/quarters/:year/:num', component: 'quarter-edit-page', guard: 'admin' },
  { pattern: '/admin/roles', component: 'roles-page', guard: 'admin' },
  { pattern: '/admin/schedule', component: 'schedule-editor-page', guard: 'admin' },
  { pattern: '/admin/matrix', component: 'availability-matrix-page', guard: 'admin' },
  { pattern: '/admin/settings', component: 'admin-settings-page', guard: 'admin' },
]);
